import {AxiosResponse} from 'axios';
import {axiosInstance} from '../..';

export function getStands(): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Stand`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function getStandId(id: string): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Stand/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}
export function createStand(data: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post('Stand', data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function updateStandId(id: string, data: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`Stand/${id}`, data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}
export function deleteStandId(id: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.delete(`Stand/${id}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}